var exports = {
  "kL": "x936d19a0--2268b6--container",
  "wx": "x936d19a0--2268b6--header",
  "fT": "x936d19a0--2268b6--expand",
  "vO": "x936d19a0--2268b6--expand_icon",
};

module.exports = exports;
